export default __webpack_public_path__ + "images/assets/5df2fe37c78276dcb880e7ebb88125cc.svg";